import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../../Utils/ApiConnect";
import { Link, useRouteMatch } from "react-router-dom";
import DeletePop from "../../../Components/DeletePop";
export default function ViewEmployee() {
  const employeeList = useSelector((state) => state.Utilities.Employee);
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const [showModal, SetshowModal] = useState(false);
  const [selectedId, SetselectedId] = useState(false);

  const FetchemployeeData = () => {
    ApiConnect.get(`/Module/Utilities/Employee/Details`)
      .then((response) => {
        let Employee = response.data;
        dispatch({ type: "SET_UTILITIES_EMPLOYEE", payload: { Employee } });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    FetchemployeeData();
  }, []);
  const columns = [
    {
      key: "name",
      text: "Name",
      sortable: true,
      cell: (record) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={record.image}
              alt={record.name}
            />
            <div className="media-body">
              <p className="lh-1">
                {record.name}
                <small className="sidetitle">{record.position}</small>
              </p>
              <small>{record.id}</small>
            </div>
          </div>
        );
      },
    },
    {
      key: "gender",
      text: "M/F",
      sortable: true,
    },
    {
      key: "blood",
      text: "B.G",
      sortable: true,
    },
    {
      key: "joining",
      text: "Joining",
      sortable: true,
      cell: (record) => {
        return (
          <React.Fragment>
            {record.joining}-{record.leaving}
          </React.Fragment>
        );
      },
    },
    {
      key: "department",
      text: "Department",
      sortable: true,
    },
    {
      key: "address",
      text: "Address",
      sortable: true,
    },
    {
      key: "contact",
      text: "Contact",
      sortable: true,
      cell: (record) => {
        return <a href={`tel:${record.contact}`}>{record.contact}</a>;
      },
    },
    {
      key: "action",
      text: "Action",
      className: "table-actions",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        return (
          <React.Fragment>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${record.id}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetshowModal(true);
                SetselectedId(record.id);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      excel: true,
      print: true,
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };

  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <div className="card-body">
          <div className="dataTables_wrapper">
            <ReactDatatable
              className="table table-separated"
              config={config}
              records={employeeList}
              columns={columns}
            />
          </div>
          <DeletePop
            trigger={showModal}
            delUrl={`/Module/Utilities/Employee/DeleteEmployee?id=${selectedId}`}
            hideTrigger={SetshowModal}
            fallAction={FetchemployeeData}
          />
        </div>
      </div>
    </div>
  );
}
